<fui-commands (toggled$)="commandsToggled($event)" [icon]="icon" [title]="title">
    <fui-command *ngIf="showAddMenu" (clicked$)="insertMenu()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.addMenu'">
    </fui-command>
    <fui-command (clicked$)="edit()" *ngIf="showEdit"
                 [title]="'wbo.screen-layout.edit.action.touchItem.' + editLabel">
    </fui-command>
    <fui-command (clicked$)="insertBlank()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.insertBlank'">
    </fui-command>
    <fui-command (clicked$)="insertSubMenu()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.addSubMenu'">
    </fui-command>
    <fui-command (clicked$)="insertProductLine()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.addProductLine'">
    </fui-command>
    <fui-command (clicked$)="insertNewProductLine()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.addNewProductLine'">
    </fui-command>
    <fui-command (clicked$)="insertCompositeProduct()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.addCompositeProduct'">
    </fui-command>
    <fui-command (clicked$)="insertExtra()"
                 [title]="'wbo.screen-layout.edit.action.touchItem.addExtra'">
    </fui-command>
    <fui-command
        (clicked$)="insertPreparationModifier()"
        [title]="'wbo.screen-layout.edit.action.touchItem.addPreparationModifier'">
    </fui-command>
    <fui-command (clicked$)="insertSize()" [title]="'wbo.screen-layout.edit.action.touchItem.addSize'">
    </fui-command>
</fui-commands>
